import { ClaimAction, ClaimActionTypes, ClaimState } from "./types";

const initialState: ClaimState = {
  id: "",
  name: "",
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  address_1: "",
  address_2: "",
  city: "",
  state: "",
  zip: "",
  allowSMS: false,
  store_of_purchase: "",
  retailer_phone: "",
  retailer_address_1: "",
  retailer_address_2: "",
  retailer_city: "",
  retailer_state: "",
  retailer_zip: "",
  purchase_date: "",
  invoice_image: "",
  date_of_incident: "",
  product_size: "",
  product_type: "",
  mattress_stained_damaged: null,
  type_of_stain_damage: "",
  protector_encasement_stained_damaged: null,
  type_of_stain_damage_protector: "",
  estimated_mattress_retail_value: 0,
  damageNotes: "",
  did_you_clean_the_protector_encasement: null,
  encasement_on_your_bed_at_the_time_of_the_incident: null,
  mattress_damage_images: [],
  protector_damage_images: [],
  protectall_tag_image: "",
};

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    case ClaimAction.UPDTAE_CLAIM_STATE: {
      const mappedState = Object.keys(action?.payload || {}).reduce(
        (acc, key) => {
          acc[key] = action?.payload[key];
          return acc;
        },
        {}
      );
      return {
        ...state,
        ...mappedState,
      };
    }

    case ClaimAction.CLEAN_UP: {
      return {
        id: "",
        name: "",
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zip: "",
        allowSMS: false,
        store_of_purchase: "",
        retailer_phone: "",
        retailer_address_1: "",
        retailer_address_2: "",
        retailer_city: "",
        retailer_state: "",
        retailer_zip: "",
        purchase_date: "",
        invoice_image: "",
        date_of_incident: "",
        product_size: "",
        product_type: "",
        mattress_stained_damaged: null,
        type_of_stain_damage: "",
        protector_encasement_stained_damaged: null,
        type_of_stain_damage_protector: "",
        estimated_mattress_retail_value: 0,
        damageNotes: "",
        did_you_clean_the_protector_encasement: null,
        encasement_on_your_bed_at_the_time_of_the_incident: null,
        mattress_damage_images: [],
        protector_damage_images: [],
        protectall_tag_image: "",
      };
    }

    default:
      return state;
  }
};
